import { Injectable } from "@angular/core";
import { Query, ResolverParams, ResolverService } from "./api/resolver.service";
import { KFeathers } from "./api/feathers.service";
import _ from "lodash";
import { Customer, ICustomer } from "../models/customer.model";
import { Contact } from "../models/customer-contact";
import { L2PUBProject } from "../models/projects/submodels/l2pub-project.model";
import { IRiverflowJobType, RiverflowJobType } from "../models/riverflow/riverflow-job-types.model";


@Injectable({ providedIn: 'root' })
export class RiverflowJobTypeService extends ResolverService<RiverflowJobType> {
    path: string = 'riverflow/job-types';
    model: new (any: any) => RiverflowJobType = RiverflowJobType;

    constructor(
        protected feather: KFeathers,
    ) {
        super(feather);
    }

}